/* eslint-disable @typescript-eslint/ban-types */
import {
  ColumnInstance as CI,
  Column as COL,
  HeaderGroup as HG,
  PluginHook,
  SortingRule as SR,
  TableInstance as TI,
  TableOptions as TO,
  TableState as TS,
  useTable as useReactTable,
  UseTableInstanceProps as UT,
} from 'react-table';
import { Optional } from '../utils/Util';

export type Column<D extends object = {}, C extends object = {}> = {
  data?: Optional<C>;
} & COL<D>;

export type SortingRule<D extends object = {}, C extends object = {}> = {
  data: C;
} & SR<D>;

export type TableState<D extends object = {}, C extends object = {}> = {
  sortBy: Array<SortingRule<D, C>>;
} & TS<D>;

export type TableOptions<D extends object = {}, C extends object = {}> = {
  columns: ReadonlyArray<Column<D, C>>;
} & TO<D>;

export type ColumnInstance<D extends object = {}, C extends object = {}> = {
  data?: Optional<C>;
} & CI<D>;

export type HeaderGroup<D extends object = {}, C extends object = {}> = {
  data?: Optional<C>;
  headers: HeaderGroup<D, C>[];
} & HG<D>;

export type UseTableInstanceProps<
  D extends object = {},
  C extends object = {}
> = {
  columns: Array<ColumnInstance<D, C>>;
  allColumns: Array<ColumnInstance<D, C>>;
  headers: Array<ColumnInstance<D, C>>;
  flatHeaders: Array<ColumnInstance<D, C>>;
  headerGroups: Array<HeaderGroup<D, C>>;
} & UT<D>;

export type TableInstance<
  D extends object = {},
  C extends object = {}
> = UseTableInstanceProps<D, C> & TI<D>;

type UseTableType = <D extends object = {}, C extends object = {}>(
  options: TableOptions<D, C>,
  ...plugins: Array<PluginHook<D>>
) => TableInstance<D, C>;

export const useTable: UseTableType = useReactTable as unknown as UseTableType;
